/**
 * Utility for generating blur data URLs for Next.js Image placeholder
 */

// Simple blur data URL for placeholder - a subtle gradient
export const BLUR_DATA_URL = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmVyc2lvbj0iMS4xIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImciPjxzdG9wIHN0b3AtY29sb3I9IiNmM2Y0ZjYiIG9mZnNldD0iMjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI2U1ZTdlYiIgb2Zmc2V0PSI1MCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjZjNmNGY2IiBvZmZzZXQ9IjcwJSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0idXJsKCNnKSIvPjwvc3ZnPg=="

/**
 * Generate a blur data URL for a given width and height
 * @param width - Width of the blur placeholder
 * @param height - Height of the blur placeholder
 * @returns Base64 encoded SVG data URL
 */
export function generateBlurDataURL(width: number = 40, height: number = 40): string {
  const svg = `
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <defs>
        <linearGradient id="g">
          <stop stop-color="#f3f4f6" offset="20%"/>
          <stop stop-color="#e5e7eb" offset="50%"/>
          <stop stop-color="#f3f4f6" offset="70%"/>
        </linearGradient>
      </defs>
      <rect width="${width}" height="${height}" fill="url(#g)"/>
    </svg>
  `.trim()
  
  return `data:image/svg+xml;base64,${Buffer.from(svg).toString('base64')}`
}

/**
 * Get blur data URL for Next.js Image component
 * Only returns a blur data URL if placeholder is 'blur'
 */
export function getBlurDataURL(placeholder?: 'blur' | 'empty', width?: number, height?: number): string | undefined {
  if (placeholder === 'blur') {
    return width && height ? generateBlurDataURL(width, height) : BLUR_DATA_URL
  }
  return undefined
}